import React, { useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import DefaultButton from "../../styles/materialButtonStyle";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import DialogModal from "../dialogModal/DialogModal";
import { useTranslation } from "react-i18next";

const RetriggerTelegramDrainButton = ({ id, setNotification, notification, fetch }) => {
  const { t } = useTranslation("otherInterface");
  const [open, setOpen] = useState(false);

  const handleRetrigger = () => {
    axios.patch("/api/payments/retrigger-telegram-drain/" + id, {}, userAuthenticationConfig())
      .then(response => {
        if (response.status === 204) {
          setNotification({ ...notification, visible: true, type: "success", message: t("retriggerTelegramDrain.success") });
          setOpen(false);
          fetch();
        }
      })
      .catch(error => {
        setOpen(false);
        parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
      });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("retriggerTelegramDrain.title")}
        content={t("retriggerTelegramDrain.content")}
        cancelButton={t("retriggerTelegramDrain.cancelButton")}
        approveButton={t("retriggerTelegramDrain.approveButton")}
        onApprove={handleRetrigger}
      />
      <DefaultButton
        color="warning"
        onClick={() => setOpen(true)}
      >
        Retrigger Drain
      </DefaultButton>
    </>
  );
};

export default RetriggerTelegramDrainButton;
